import { createApi } from '@reduxjs/toolkit/query/react';
import { format } from 'date-fns';
import { chronosApi } from 'api';

const timezoneOffset = new Date().getTimezoneOffset();

function formatDateString(stat) {
  stat.dateString = format(new Date(stat.date), 'd MMM');
  return stat;
}

const statsApi = createApi({
  reducerPath: 'chronosApi',
  endpoints: (build) => ({
    getWorklogStats: build.query({
      queryFn: async ({ dateFrom, dateTo }) => {
        const { worklogStatsByDay, worklogStatsByWeek, worklogStatsByMonth } =
          await chronosApi.getWorklogStats({
            body: {
              dateFrom,
              dateTo,
            },
          });

        return {
          data: {
            worklogStatsByDay: worklogStatsByDay.map(formatDateString),
            worklogStatsByWeek: worklogStatsByWeek.map(formatDateString),
            worklogStatsByMonth: worklogStatsByMonth.map(formatDateString),
          },
        };
      },
    }),
    getAccountStats: build.query({
      queryFn: async ({ dateFrom, dateTo }) => {
        const {
          activeWorkspaces,
          activePaidWorkspaces,
          activeTrialWorkspaces,
          activePaidAccounts,
          snapsByDay,
          predict,
        } = await chronosApi.getAccountStats({
          body: {
            dateFrom,
            dateTo,
          },
        });
        return {
          data: {
            predict,
            activeWorkspaces,
            activePaidWorkspaces,
            activePaidAccounts,
            activeTrialWorkspaces,
            snapsByDay: snapsByDay.map(formatDateString),
          },
        };
      },
    }),
    getTransactionStats: build.query({
      queryFn: async ({ dateFrom, dateTo }) => {
        const {
          transactionStatsByDay,
          transactionStatsByWeek,
          transactionStatsByMonth,
        } = await chronosApi.getTransactionStats({
          body: {
            dateFrom,
            dateTo,
            timezoneOffset,
          },
        });
        return {
          data: {
            transactionStatsByDay: transactionStatsByDay.map(formatDateString),
            transactionStatsByWeek:
              transactionStatsByWeek.map(formatDateString),
            transactionStatsByMonth:
              transactionStatsByMonth.map(formatDateString),
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetWorklogStatsQuery,
  useGetAccountStatsQuery,
  useGetTransactionStatsQuery,
} = statsApi;
export default statsApi;
